import {Button, Col, FloatingLabel, Form, InputGroup, Offcanvas, Row, Spinner} from 'react-bootstrap'
import {useEffect, useMemo, useState} from 'react'
import {useMutation} from '@apollo/client'
import {toast} from 'react-toastify'
import {SEND_MAIL} from '../../../../gql/mutations/integrationsMutations'
import {LeadByID} from '../../leadTypes'
import {useGetUser} from '../../../../store/userStore'

interface SendEmailResponse {
  sendEmail: {success: boolean; errorMessage?: string | null}
}

export const FormSendMail: React.FC<{onBack: () => void; lead: LeadByID}> = ({onBack, lead}) => {
  const [sendEmail, {loading}] = useMutation<SendEmailResponse>(SEND_MAIL)
  const user = useGetUser((s) => s.user?.user)
  const userName = useMemo(() => {
    const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim()
    return fullName || user?.email || 'N/R'
  }, [user?.firstName, user?.lastName, user?.email])

  const [toEmail, setToEmail] = useState(lead.email || '')
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')

  useEffect(() => {
    const signature = `\n\n\n\n${userName}\nThe Future Insurance\nCopyrights © All rights reserved.`
    setMessage(signature)
  }, [userName])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!toEmail || !subject || !message) {
      toast.error('Please complete all required fields.')
      return
    }
    try {
      const {data} = await sendEmail({variables: {toEmail, subject, message}})
      if (data?.sendEmail?.success) {
        toast.success('Email sent successfully.')
        onBack()
        return
      }
      toast.error(`Error: ${data?.sendEmail?.errorMessage || 'Unable to send email'}`)
    } catch (err) {
      toast.error(`Error: ${String(err)}`)
    }
  }
  return (
    <>
      <Offcanvas.Header closeButton className='bg-light'>
        <div className='d-flex align-items-center justify-content-between w-100'>
          <Offcanvas.Title className='d-flex align-items-center gap-4'>Send Email</Offcanvas.Title>
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <form onSubmit={handleSubmit}>
          <div className='w-100 h-100'>
            <div>
              <Row>
                <Col className='col-12 mb-4'>
                  <FloatingLabel controlId='from' label='From' className='mb-3'>
                    <Form.Control placeholder='From' name='from' value={user?.email || ''} disabled />
                  </FloatingLabel>
                </Col>
                <Col className='col-12 mb-4'>
                  <FloatingLabel
                    controlId='to'
                    label={
                      <span>
                        To <span style={{color: 'red'}}>*</span>
                      </span>
                    }
                    className='mb-3'
                  >
                    <Form.Control
                      placeholder='to'
                      name='to'
                      value={toEmail}
                      onChange={(e) => setToEmail(e.target.value)}
                    />
                  </FloatingLabel>
                </Col>
                <Col className='col-12 mb-4'>
                  <InputGroup className='mb-3'>
                    <FloatingLabel
                      controlId='subject'
                      label={
                        <span>
                          Subject <span style={{color: 'red'}}>*</span>
                        </span>
                      }
                    >
                      <Form.Control
                        name='subject'
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                      />
                    </FloatingLabel>
                    <InputGroup.Text id='basic-addon2'>Cc</InputGroup.Text>
                    <InputGroup.Text id='basic-addon3'>Bcc</InputGroup.Text>
                  </InputGroup>
                </Col>
                <Col className='col-12 mb-4'>
                  <FloatingLabel
                    controlId='message'
                    label={
                      <span>
                        Message <span style={{color: 'red'}}>*</span>
                      </span>
                    }
                    className='mb-3'
                  >
                    <Form.Control
                      placeholder='Message'
                      as='textarea'
                      rows={12}
                      type='textarea'
                      name='message'
                      className='h-100'
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                  </FloatingLabel>
                </Col>
              </Row>
            </div>
            <div className='d-flex algin-items-center justify-content-end gap-3 mt-4'>
              <Button type='button' variant='light' onClick={onBack}>
                Cancel
              </Button>
              <Button type='submit' variant='primary' disabled={loading || !toEmail || !subject}>
                {loading ? <Spinner animation='border' size='sm' /> : 'Send'}
              </Button>
            </div>
          </div>
        </form>
      </Offcanvas.Body>
    </>
  )
}
